import { render } from "./RecordingsAdmin.vue?vue&type=template&id=426e62ab&scoped=true"
import script from "./RecordingsAdmin.vue?vue&type=script&lang=js"
export * from "./RecordingsAdmin.vue?vue&type=script&lang=js"

import "./RecordingsAdmin.vue?vue&type=style&index=0&id=426e62ab&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426e62ab"]])

export default __exports__